import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../subpage.css';

// Shared shell for the static content pages (About / Terms / Privacy).
// Renders the fixed header, the gradient hero, the decorative cover, and the
// prose article. `cover` is the cover modifier class + its inline SVG decoration.
export default function SubpageLayout({ title, lede, cover, children, docTitle }) {
  useEffect(() => {
    if (docTitle) {
      const prev = document.title;
      document.title = docTitle;
      return () => { document.title = prev; };
    }
  }, [docTitle]);

  const navLinks = [
    ['Features', '/#features'],
    ['Games', '/#games'],
    ['Devices', '/#devices'],
    ['Pricing', '/#pricing'],
  ];

  return (
    <>
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
        background: 'rgba(7,6,11,0.72)',
        backdropFilter: 'blur(14px) saturate(140%)',
        WebkitBackdropFilter: 'blur(14px) saturate(140%)',
        borderBottom: '1px solid var(--line)',
      }}>
        <div className="wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
          <Link to="/" aria-label="Game Accelerator" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src="/assets/logo.png" alt="Game Accelerator"
              style={{ height: 32, width: 'auto', display: 'block', filter: 'drop-shadow(0 0 18px rgba(154,86,255,0.35))' }} />
          </Link>
          <nav style={{ display: 'flex', gap: 4 }} className="nav-links">
            {navLinks.map(([label, href]) => (
              <a key={label} href={href} style={{ padding: '8px 14px', fontSize: 14, color: 'var(--text-2)', borderRadius: 8 }}>{label}</a>
            ))}
          </nav>
          <a href="/#pricing" className="btn btn--primary btn--sm">Get Accelerator</a>
        </div>
      </header>

      <main>
        <section className="subpage-hero">
          <div className="grid-bg" />
          <div className="hero-bg"><div className="orb" /></div>
          <div className="wrap" style={{ position: 'relative' }}>
            <h1>{title}</h1>
            <p className="lede">{lede}</p>
          </div>
        </section>

        <div className="wrap">
          {cover}
          <article className="prose">
            {children}
            <Link to="/" className="back-link">← Back to home</Link>
          </article>
        </div>
      </main>

      <style>{`
        @media (max-width: 700px) { .subpage-hero .nav-links, header .nav-links { display: none; } }
      `}</style>
    </>
  );
}
